import { Card, CardFooter, CardHeader, Image, makeStyles, Persona, Text, Title2, Title3 } from "@fluentui/react-components";
import { Link } from "react-router-dom";
import { Avatar } from "../../components/avatar/Avatar";
import ITeamMember from "../../models/ITeamMember";
import { dolphinTokens } from "../../utils/Theme";
import IEntryPreivew from "../../models/blog/IEntryPreview";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
    card: {
        height: 'fit-content',
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',

        "@media (max-width: 768px)": {
            backgroundColor: dolphinTokens.colorDarkBlue,
            color: 'white'
        }
    },
    cardCol: {
        width: '100%',
        margin: '0',

        "@media (max-width: 768px)": {
            width: '100%',
            // padding: "0 1rem"
        }
    },
    cardImage: {
        width: 'calc(33% - 24px)',
        height: '200px',
        objectFit: 'cover',

        "@media (max-width: 768px)": {
            display: 'none'
        }
    },
    cardTitle: {
        margin: "0 0 1rem 0",
    },
    cardDescription: {
        display: 'block',
        margin: '0 0 1rem 0',
        color: '#555',
    },
    cardButton: {
        marginTop: 'auto',
        width: '100%',
    },
    link: {
        textDecoration: 'none'
    },
    persona: {
        marginTop: '8px',

        "@media (max-width: 768px)": {
            "& span": {
                color: 'white !important'
            }
        }
    }
});

export default function FeaturedBlogCard(props:{ blog: IEntryPreivew }) {
    const { t } = useTranslation("blog");
    const { blog } = props;
    const styles = useStyles();

    const person: ITeamMember = {
        id: blog.authorId!,
        name: blog.author!,
        position: ""
    };

    const publishedDate = new Date(blog.published);
    const publishedStr = publishedDate.toDateString();
    const readTime = blog.readTime
        ? blog.readTime === 1
            ? t("readTime.one")
            : t("readTime.other", { count: blog.readTime })
        : "";

    return (
        <div className={styles.cardCol}>
            <Link to={`/blog/${blog.slug}`} className={styles.link}>
                <Card className={styles.card} orientation="horizontal">
                    <Image
                        src={blog.thumbnail.url}
                        alt={blog.thumbnail.altText}
                        className={styles.cardImage}
                    />
                    <div>
                        <CardHeader
                            header={<Title3 block as="h3" className={styles.cardTitle}>{blog.title.title}</Title3>}
                            description={<Text block className={styles.cardDescription}>{blog.metaDescription}</Text>}
                            />
                        <Persona
                            name={person.name}
                            avatar={Avatar(person)}
                            secondaryText={publishedStr}
                            tertiaryText={readTime}
                            className={styles.persona}
                            size="huge"
                            />
                    </div>
                </Card>
            </Link>
        </div>
    );
}